import { useState } from "react";

type useToggleListReturn<T> = {
  list: T[];
  hasLengthOf: (items: unknown[]) => boolean;
  includesItem: (item: T) => boolean;
  toggleItem: (item: T) => void;
  removeItem: (item: T) => void;
  clear: () => void;
  setList: (xs: T[]) => void;
  hasSelection: boolean;
};

/**
 * Manages a list of primitive values and provides a `toggleItem` function to "toggle" an entry.
 * If the item is present, it is removed from the list.
 * If the item is NOT present, it is added to the list.
 */
const useToggleList = <T>(initial: T[] = []): useToggleListReturn<T> => {
  const [list, setList] = useState(initial);

  return {
    list,
    setList,
    hasLengthOf: (items: unknown[]) => items.length === list.length,
    hasSelection: list.length > 0,
    includesItem: (item: T) => list.includes(item),
    toggleItem: (item: T) => setList(list.includes(item) ? list.filter((x) => x !== item) : [...list, item]),
    removeItem: (item: T) => setList(list.filter((x) => x !== item)),
    clear: () => setList([]),
  };
};

export default useToggleList;
